"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadGoogleDrive;

var _loadScript = _interopRequireDefault(require("FileManagerCore/utils/loadScript"));

var GOOGLE_DRIVE_SCRIPT_URL = 'https://apis.google.com/js/api.js';

function loadGoogleDrive() {
  return (0, _loadScript.default)(GOOGLE_DRIVE_SCRIPT_URL);
}

module.exports = exports.default;